import React from 'react';
import { RenderOptionFunction } from '@workday/canvas-kit-preview-react/select';

export const RenderOption: RenderOptionFunction = option => {
    return (
        <div style={{ alignItems: 'center', display: 'flex', padding: '3px 0' }}>
            <div style={{ marginLeft: 5 }}>{option.label}</div>
        </div>
    );
};
